import React from 'react';

const BookingStepService = ({ services, formData, setFormData, setStep }) => (
  <div className="space-y-4">
    <h3 className="text-base sm:text-lg font-semibold text-stone-800">Select Service</h3>
    <div className="grid gap-2 sm:gap-3 max-h-[50vh] overflow-y-auto pr-1">
      {services.map((service) => (
        <button
          key={service.id}
          onClick={() => {
            setFormData({ ...formData, service });
            setStep(2);
          }}
          className={`p-3 sm:p-4 rounded-xl border-2 text-left transition-all ${
            formData.service?.id === service.id 
              ? 'border-luxury-green bg-sage-50' 
              : 'border-stone-200 hover:border-sage-300'
          }`}
        >
          <div className="flex justify-between items-start gap-2">
            <div className="flex-1 min-w-0">
              <p className="font-medium text-stone-800 text-sm sm:text-base truncate">{service.name}</p>
              <p className="text-xs sm:text-sm text-stone-500">{service.duration}</p>
              {service.name.toLowerCase().includes('couple') && (
                <p className="text-[10px] text-rose-500 mt-0.5">One booking for 2 people side by side — total for both: €{service.price * 2}</p>
              )}
            </div>
            <span className="text-base sm:text-lg font-semibold text-luxury-green flex-shrink-0">
              €{service.price}
              {service.name.toLowerCase().includes('couple') && (
                <span className="text-[10px] font-normal text-stone-400 block text-right">per person</span>
              )}
            </span>
          </div>
        </button>
      ))}
    </div>
  </div>
);

export default BookingStepService;
